import { Link } from "react-router-dom";

import { useEffect } from "react";
import { Helmet } from "react-helmet";

function Career() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Helmet>
        <title>Career </title>

      </Helmet>

        <div class="block-style-thirtySix bg-white border-bottom lg-container pt-110  pb-80" id="feature">
          <div class="container">
            <div class="row">
              <div class="col-xl-6 col-lg-7  " >
                <div class="pl-lg-5">
                  <div class="title-style-fourteen">
                    <h6><span class="upper-title custom-name">Career </span></h6>
                    <h1>Be a Part of ‍Someting Great
                    </h1>
                  </div>

                  <p className="mainp">Elevate your career journey with <strong>TaskFlier!</strong> Access invaluable insights and connect with industry leaders. Join us today and unlock your full potential.
                  </p>


                  <Link class="theme-btn-2 mt-10 md-mt-30" to="/demo-request">Request Demo <i class="bi bi-arrow-right pl-2"></i></Link>

                </div>
              </div>

              <div class="col-xl-6 col-lg-5 text-center text-lg-left  " >
                <div class=" d-inline-block md-mt-60">
                  <img src="/main/images/Consulting-Services.png" alt="Consulting-Services" class="w-100" />

                </div>
              </div>
            </div>
          </div>
        </div>



        <div class="fancy-feature-thirtyFour pt-80 pb-100 bg-gray">
          <div class="container">
            <div class="title-style-two text-center mb-40 md-mb-40">

              <h6><span class="upper-title custom-name mb-10">Get going with Taskflier </span></h6>
              <h3 class="maintitle "><span>Why Work With Us?</span></h3>




            </div>

            <div class="row  features">


              <div class="col-lg-4 col-12 ">

                <div class="Solutions-box " >
                  <img src="/main/images/task-creation.png" alt="Task creation" class="w-100" />
                  <h6 className="mt-1"><span class="upper-title custom-name">Inclusive Culture </span></h6>
                  <div class="pack-name mt-2 text-capitalize">Empowerment Through Diversity: Thriving Together in Unity</div>
                  <hr></hr>
                  <p className="mainp">We imbibe a culture that celebrates diversity and encourages individuality. At TaskFlier, everyone’s voice is heard, and each employee plays a vital role in our success.</p>


                </div>

              </div>
              <div class="col-lg-4 col-12 ">

                <div class="Solutions-box " >
                  <h6 className="mt-1"><span class="upper-title custom-name">Collaborative Environment</span></h6>
                  <div class="pack-name mt-2 text-capitalize">Shared Vision: Driving Innovation with Collaborative Team Dynamics
                  </div>
                  <hr></hr>
                  <p className="mainp">Our team-oriented approach promotes collaboration across all levels of the organization. You will have the opportunity to work with talented professionals from diverse backgrounds and expertise</p>
                  <img src="/main/images/customizing-taskboard.png" alt="Customizing taskboard" class="w-100" />
                </div>

              </div>
              <div class="col-lg-4 col-12 ">

                <div class="Solutions-box " >
                  <img src="/main/images/task-dependencies.png" alt="Task dependencies" class="w-100" />
                  <h6 className="mt-1"><span class="upper-title custom-name">Work-Life Balance </span></h6>
                  <div class="pack-name mt-2 text-capitalize">Achieving Harmony Between ‍Work and Home Life</div>
                  <hr></hr>
                  <p className="mainp">We understand the importance of balancing professional and personal life. We offer flexible working hours, remote work options, and comprehensive wellness programs to support our employees' well-being.</p>

                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="fancy-feature-fortySix lg-container mega-feature pt-100 pt-100 pb-150 md-pt-80 lg-pb-80" id="feature">
          <div class="container">
            <div class="title-style-two text-center mb-40 md-mb-40">
              <h2>
                <span>
                  Why Join Us?

                </span>
              </h2>
              <div class="sub-text mt-15 maxsubtitle">
                Joining our team offers a wealth of opportunities for both personal <br></br> and professional growth
              </div>
            </div>
            <div class="title-style-twelve">

              <div class="row justify-content-center">
                <div class="col-lg-4 col-md-6 d-flex aos-init aos-animate" data-aos="fade-up" data-aos-duration="1200">
                  <div class="block-style-five">
                    <div class="icon"><img src="images/icon/20.svg" alt="" /></div>
                    <h6 class="title"><span>Employee Centric Facilities</span></h6>
                    <p>Our facilities prioritize comfort and collaboration, featuring modern amenities that enhance productivity, foster innovation, and support your professional growth.</p>
                  </div>

                </div>
                <div class="col-lg-4 col-md-6 d-flex aos-init aos-animate" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="100">
                  <div class="block-style-five">
                    <div class="icon"><img src="images/icon/21.svg" alt="" /></div>
                    <h6 class="title"><span>Reward & Recognition</span></h6>
                    <p>We offer competitive rewards and recognition programs to celebrate achievements and exceptional contributions to our success.</p>
                  </div>

                </div>
                <div class="col-lg-4 col-md-6 d-flex aos-init aos-animate" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="200">
                  <div class="block-style-five">
                    <div class="icon"><img src="images/icon/22.svg" alt="" /></div>
                    <h6 class="title"><span>Career growth</span></h6>
                    <p>We provide robust development opportunities, nurturing potential and ensuring every team member has the tools to succeed and advance in their career.</p>
                  </div>

                </div>

                <div class="col-lg-4 col-md-6 d-flex aos-init aos-animate" data-aos="fade-up" data-aos-duration="1200">
                  <div class="block-style-five">
                    <div class="icon"><img src="images/icon/20.svg" alt="" /></div>
                    <h6 class="title"><span>Health and Wellness</span></h6>
                    <p>Comprehensive health insurance plans, including medical, dental, and vision coverage. Access to wellness programs, and fitness incentives.</p>
                  </div>

                </div>
                <div class="col-lg-4 col-md-6 d-flex aos-init aos-animate" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="100">
                  <div class="block-style-five">
                    <div class="icon"><img src="images/icon/21.svg" alt="" /></div>
                    <h6 class="title"><span>Great culture</span></h6>
                    <p>Experience a supportive and inclusive work environment that fosters collaboration, innovation, and mutual respect among all team members.</p>
                  </div>

                </div>
                <div class="col-lg-4 col-md-6 d-flex aos-init aos-animate" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="200">
                  <div class="block-style-five">
                    <div class="icon"><img src="images/icon/22.svg" alt="" /></div>
                    <h6 class="title"><span>Flexible Work Arrangements</span></h6>
                    <p>Benefit from flexible hours and remote work options, allowing you to tailor your schedule for a balanced work-life harmony.</p>
                  </div>

                </div>
              </div>







            </div>

          </div>
        </div>


        <div class="fancy-feature-thirtyTwo  pb-80  bg-white">
          <div class="container">
            <div class="title-style-two text-center mb-40 md-mb-40">
              <h2>
                <span>
                  We are looking for...

                </span>
              </h2>

            </div>
            <div class="row  features ">


              <div class="col-lg-6 col-12 ">

                <div class="Solutions-box choose-right-wrapper featured-box Career " >
                  <div class="bg-wrapper d-lg-flex align-items-center justify-content-between Career">
                    <h6 className="font-12 text-muted">Full Time </h6>
                    <h6 className="mt-1"><span class="upper-title  custom-name text-primary">Sales</span></h6>
                  </div>

                  <h4 class="mt-2 text-capitalize fw-500 font-18">Head - Customer Success </h4>

                  <p className="mainp">We imbibe a culture that celebrates diversity and encourages individuality. At TaskFlier, everyone’s voice is heard, and each employee plays a vital role in our success.</p>
                  <i class="bi bi-arrow-right"></i>

                </div>

              </div>
              <div class="col-lg-6 col-12 ">

                <div class="Solutions-box choose-right-wrapper featured-box Career " >
                  <div class="bg-wrapper d-lg-flex align-items-center justify-content-between">
                    <h6 className="font-12 text-muted">Full Time </h6>
                    <h6 className="mt-1"><span class="upper-title custom-name text-primary">Marketing</span></h6>
                  </div>

                  <h4 class="mt-2 text-capitalize fw-500 font-18">Content Writer</h4>

                  <p className="mainp">Our team-oriented approach promotes collaboration across all levels of the organization. You will have the opportunity to work with talented professionals from diverse backgrounds and expertise</p>
                  <i class="bi bi-arrow-right"></i>
                </div>

              </div>

            </div>




          </div>
        </div>

    </>
  );
}

export default Career;